// import Vue from 'vue'
import getItems from '@/api/items/getItems'
import setItems from '@/api/items/setItems'
import getTransactions from '@/api/items/getTransactions'
import getSingleItem from '@/api/items/getSingleItem'
import deleteItem from '@/api/items/deleteItem'
import setTransactions from '@/api/items/setTransactions'

const state = {
  items: [],
  singleItem: {},
  transactions: [],
}

const actions = {
  getItemsAction({ commit }, data) {
    return new Promise((resolve, reject) => {
      getItems
        .call(this, { status: data?.status })
        .then(response => {
          if (response.status == 'OK') {
            commit('setItemsMutation', { items: response.data })
            resolve()
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  saveItemsAction({ commit }, { item }) {
    return new Promise((resolve, reject) => {
      setItems
        .call(this, { items: [item] })
        .then(response => {
          if (response.status == 'OK') {
            commit('updateItemsMutation', { items: response.data })
            resolve(response.data)
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  getSingleItemAction({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      getSingleItem
        .call(this, id)
        .then(response => {
          if (response.status == 'OK') {
            commit('setSingleItemMutation', { item: response.data })
            resolve()
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  deleteItemsAction({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteItem
        .call(this, id)
        .then(response => {
          if (response.status == 'OK') {
            commit('deleteItemsMutation', { item: response.data })
            resolve()
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  getTransactionsAction({ commit }, data) {
    return new Promise((resolve, reject) => {
      getTransactions
        .call(this, data)
        .then(response => {
          if (response.status == 'OK') {
            commit('setTransactionsMutation', { transactions: response.data })
            resolve()
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
  saveTransactionsAction({ commit }, { itemId, transaction }) {
    return new Promise((resolve, reject) => {
      setTransactions
        .call(this, { itemId, transactions: [transaction] })
        .then(response => {
          if (response.status == 'OK') {
            commit('updateTransactionsMutation', { transactions: response.data })
            resolve(response.data)
          } else {
            reject(new Error(response.message))
          }
        })
        .catch(e => {
          reject(new Error(e))
        })
    })
  },
}

const mutations = {
  setItemsMutation(state, { items }) {
    state.items = items
  },
  updateItemsMutation(state, { items }) {
    items.forEach(item => {
      const index = state.items.findIndex(r => r.id == item.id)
      if (index !== -1 && typeof index !== 'undefined') {
        state.items.splice(index, 1, item)
      } else {
        state.items = [...state.items, item]
      }
      if (item.id == state.singleItem.id) {
        state.singleItem = item
      }
    })
  },
  setSingleItemMutation(state, { item }) {
    state.singleItem = item
  },
  deleteItemsMutation(state, { item }) {
    const index = state.items.findIndex(r => r.id == item.id)
    if (typeof index !== 'undefined') {
      state.items.splice(index, 1)
    }
  },
  setTransactionsMutation(state, { transactions }) {
    state.transactions = transactions
  },
  updateTransactionsMutation(state) {
    return state
  },
  clearTransactionsMutation(state) {
    state.transactions = []
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
